/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { ApiPromise } from "../models/ApiPromise";
import { axiosCommon } from "../util/axiosSetup";
import { Void } from "../models/Void";
import Params from "../common/Params";
import { InsuranceCompanyResponse } from "../models/insurance/InsuranceCompanyResponse";
import { NewInsuranceCompanyRequest } from "../models/insurance/NewInsuranceCompanyRequest";
import { UpdateInsuranceCompanyRequest } from "../models/insurance/UpdateInsuranceCompanyRequest";

export default class InsuranceApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static getInsuranceCompanies(): ApiPromise<InsuranceCompanyResponse[]> {
    const url = `${this.baseUrl}/insurance-companies`;
    return axiosCommon.get(url);
  }

  static getInsuranceCompaniesByCountry(
    countryCode: string
  ): ApiPromise<InsuranceCompanyResponse[]> {
    const url = `${this.baseUrl}/insurance-companies/${countryCode}`;
    return axiosCommon.get(url);
  }

  static createInsuranceCompany(
    request: NewInsuranceCompanyRequest
  ): ApiPromise<InsuranceCompanyResponse> {
    const url = `${this.baseUrl}/insurance-companies`;
    return axiosCommon.post(url, request);
  }

  static updateInsuranceCompany(
    id: string,
    request: UpdateInsuranceCompanyRequest
  ): ApiPromise<InsuranceCompanyResponse> {
    const url = `${this.baseUrl}/insurance-companies/${id}`;
    return axiosCommon.put(url, request);
  }

  static deleteInsuranceCompany(id: string): ApiPromise<Void> {
    const url = `${this.baseUrl}/insurance-companies/${id}`;
    return axiosCommon.delete(url);
  }
}
